module.exports = __webpack_public_path__ + "img/inverter.8a8b9c47.svg";